import { all } from "redux-saga/effects";
import { LoginWatcherSaga } from "./LoginPage/LoginSaga";
import { GetUserWatcherSaga } from "./GetUser/GetUserSaga";
import { ForgotAndResetPasswordWatcherSaga } from "./ForgotAndResetPassword/ForgotAndResetPasswordSaga";
import { EmployeeListWatcherSaga } from "./Employees/EmployeeSaga";
import { changepasswordWatcherSaga } from "./ChangePassword/ChangePasswordsaga";
import { CountryListWatcherSaga } from "./CountryState/Country/CountrySaga";
import { StateListWatcherSaga } from "./CountryState/State/StateSaga";
import { CronSettingWatcherSaga } from "./CronSettings/CronSettingsSaga";
import { BlockListWatcherSaga } from "./Blocklist/BlocklistSaga";
import { VisitorLogsWatcherSaga } from "./VisitorLogs/VisitorLogsSaga";
import { MasterWatcherSaga } from "./Master/MasterSaga";
import { DashboardWatcherSaga } from "./Dashboard/DashboardSaga";
import { SettingsWatcherSaga } from "./Settings/SettingsSaga";

export default function* RootSaga() {
  yield all([
    LoginWatcherSaga(),
    GetUserWatcherSaga(),
    ForgotAndResetPasswordWatcherSaga(),
    EmployeeListWatcherSaga(),
    changepasswordWatcherSaga(),
    CountryListWatcherSaga(),
    StateListWatcherSaga(),
    CronSettingWatcherSaga(),
    BlockListWatcherSaga(),
    VisitorLogsWatcherSaga(),
    MasterWatcherSaga(),
    DashboardWatcherSaga(),
    SettingsWatcherSaga(),
  ]);
}
